module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['AuraComponents']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module AuraComponents URL not available') },
        init: (arg) => { throw new Error('Module AuraComponents URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['AuraComponents'].get(request),
      init: (arg) => {
        try {
          return window['AuraComponents'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: AuraComponents')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module AuraComponents not available') },
      init: (arg) => { throw new Error('Module AuraComponents not available') }
    })
    document.head.appendChild(script);
  });